export class RequestOptions {
  ShowSuccess: boolean;
  IsDeleteAction: boolean;
  HandleGenericError: boolean;
  ShowLoader: boolean;
  ResponseType: string;
}
